import React, { useCallback } from 'react';

import { useMediaConfigSearch } from 'bdvp-common/src/hooks/config';
import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useSearchQueryParam from '../hooks/store/useSearchQueryParam';
import useSearchQuery from '../hooks/store/useSearchQuery';
import useSearchSort from '../hooks/store/useSearchSort';
import { FALLBACK_SORT } from '../utils/constants';
import Results from '../components/SearchResults';

const { FILTER_MODAL_NAME } = modalConstants;

const SearchResults = (props) => {

    const { locationSearchWasUpdated } = props;
    const {
        loading,
        data,
        error,
        loadingMore,
        fetchMoreData,
        page,
        contentPreference,
    } = useSearchQuery();
    const { searchQuery, queryType } = useSearchQueryParam();

    const config = useMediaConfigSearch();
    const { modalShow, isModalOpen } = useModalStore();

    const {
        setSearchSort,
        isSorting,
        setIsSorting,
        searchSortSelectedOption,
    } = useSearchSort();

    const resetSort = useCallback(()=> {

        setSearchSort(config.sortOptions?.[0]?.value ?? FALLBACK_SORT);

    }, [
        setSearchSort,
        config,
    ]);

    const showFilters = useCallback(() => modalShow(FILTER_MODAL_NAME), [modalShow]);
    const isFilterModalOpen = isModalOpen(FILTER_MODAL_NAME) ?? false;

    return (
        <Results
            loading={loading}
            data={data}
            error={error}
            page={page}
            loadingMore={loadingMore}
            fetchMoreData={fetchMoreData}
            searchQuery={searchQuery}
            resetSort={resetSort}
            isSorting={isSorting}
            setIsSorting={setIsSorting}
            searchSortSelectedOption={searchSortSelectedOption}
            contentPreference={contentPreference}
            queryType={queryType}
            locationSearchWasUpdated={locationSearchWasUpdated}
            showFilters={showFilters}
            isFilterActive={isFilterModalOpen}
        />
    );

};

export default SearchResults;
